<template>

  <t-page>

    <t-page-general :current-page="currentPage" :user-auth="userAuth">

      <div class="grid-menu grid-menu-2col">
        <div class="no-gutters row">

<!--          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessSubValidation('sub-general-setting-param')"
                      to="admin-setting-param">
              <i class="lnr-list btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Parâmetros
            </t-button>
          </div>-->


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('admin-profile')"
                      to="admin-profile">
              <i class="lnr-lock btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Perfis de Acesso
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('admin-group-user')"
                      to="admin-group-user">
              <i class="lnr-users btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Grupos de Usuários
            </t-button>
          </div>




          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('admin-access-control')"
                      to="admin-access-control">
              <i class="lnr-cloud-check btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Controle de Acesso por IP
            </t-button>
          </div>


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('admin-printer')"
                      to="admin-printer">
              <i class="lnr-printer btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Impressoras
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('general-label')"
                      to="general-label">
              <i class="lnr-tag btn-icon-wrapper btn-icon-lg mb-3"></i>
              Modelos de Etiquetas
            </t-button>
          </div>




        </div>
      </div>


<!--      <b-col v-for="relationPages in userAuth.relationPages" :key="relationPages.pageRelationId">
        {{ relationPages.pageTitle }}
      </b-col>-->

    </t-page-general>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"

export default {
  mixins: [pageDefaultMixin],
  name: 'AdminSettings',
  data() {
    return {

    }
  },
  methods: {

    mountedPrepare(){


    },
    async mountedContinued(){

    }

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
